import { BASE_URL } from "@/constants/endpoints";
import { CounterDeliveryListResponse } from "@/pages/grain-requests/counter-delivery/schema/counter-delivery.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let CounterDeliveryApiPromise: Promise<AxiosInstance> | null = null;

const getCounterDeliveryApi = async (): Promise<AxiosInstance | null> => {
  if (CounterDeliveryApiPromise) return CounterDeliveryApiPromise;
  CounterDeliveryApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return CounterDeliveryApiPromise;
};

export interface GetCounterDeliveriesProps {
  fecha?: string;
  monto?: number;
  estado?: string[];
  titular?: string;
  toneladas?: number;
  grano?: number;
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getCounterDeliveries = async (
  props: GetCounterDeliveriesProps,
): Promise<CounterDeliveryListResponse | null | undefined> => {
  const api = await getCounterDeliveryApi();
  if (!api) return;

  const response = await api.get(
    `/ContraEntrega/GetListadoContraEntrega?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetCounterDeliveryProps {
  id: number;
  usuario: string;
}

export const getCounterDelivery = async (props: GetCounterDeliveryProps) => {
  const api = await getCounterDeliveryApi();
  if (!api) return;

  const response = await api.get(
    `/ContraEntrega/GetDetalleContraEntrega?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateCounterDeliveryProps {
  nroCuentaOrigen: string;
  grano: number;
  cosecha: string;
  toneladas: number;
  monto: number;
  esCanje: boolean;
  mensaje: string;
  usuarioCrea: string;
}

export const createCounterDelivery = async (
  props: CreateCounterDeliveryProps,
) => {
  const api = await getCounterDeliveryApi();
  if (!api) return;

  const response = await api.post(
    `/ContraEntrega/CrearContraEntrega?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateCounterDeliveryProps {
  idSolicitud: number;
  mensaje?: string;
  usuarioActual: string;
  monto?: number;
  estado?: string;
}

export const updateCounterDelivery = async (
  props: UpdateCounterDeliveryProps,
) => {
  const api = await getCounterDeliveryApi();
  if (!api) return;

  const response = await api.put(
    `/ContraEntrega/EditarContraEntrega?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getCounterDeliveryHarvests = async () => {
  const api = await getCounterDeliveryApi();
  if (!api) return;

  const response = await api.get(`/ContraEntrega/GetCosechasContraEntrega`);

  return response.data;
};
